import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "answer-container-wrapper" }
const _hoisted_2 = {
  key: 2,
  class: "answer-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Heading3 = _resolveComponent("Heading3")!
  const _component_FetchingError = _resolveComponent("FetchingError")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_QuizAnswer = _resolveComponent("QuizAnswer")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Heading3, { class: "quiz-question" }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.getQuestion()), 1)
      ]),
      _: 1
    }),
    _createElementVNode("form", {
      onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submitAnswer && _ctx.submitAnswer(...args)), ["prevent"])),
      class: "quiz"
    }, [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.fetchingError)
          ? (_openBlock(), _createBlock(_component_FetchingError, { key: 0 }))
          : (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_Loader, { key: 1 }))
            : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeQuestionAnswers, (answer) => {
                  return (_openBlock(), _createBlock(_component_QuizAnswer, {
                    key: answer.id,
                    id: answer.id,
                    title: answer.title,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedAnswer = $event))
                  }, null, 8, ["id", "title"]))
                }), 128))
              ]))
      ]),
      _createVNode(_component_Button, {
        variant: "primary",
        disabled: !_ctx.selectedAnswer
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.checkIfLastQuestion() ? "Submit" : "Next question"), 1)
        ]),
        _: 1
      }, 8, ["disabled"])
    ], 32),
    (_ctx.numberOfQuestions)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          width: _ctx.getProgressBarCompleteness(),
          content: _ctx.getProgressBarContent()
        }, null, 8, ["width", "content"]))
      : _createCommentVNode("", true)
  ]))
}